// extracted by mini-css-extract-plugin
export default {"divider":"AttachmentAddPopup_divider__d7zXW","menu":"AttachmentAddPopup_menu__9bcSG","menuItem":"AttachmentAddPopup_menuItem__Kjno5","tip":"AttachmentAddPopup_tip__yDlZQ"};